const { formatMoney } = window.BAO.Utils

class Loyalty {
  init () {
    document.addEventListener('swell:setup', () => {
      if (window.swellAPI) {
        this.customerDetails = window.swellAPI.getCustomerDetails()

        this.renderPoints()
        this.renderTier()
        this.renderSpend()
        this.renderPound()
        this.renderSpendSlider()
      }

      document.addEventListener('loyalty:update', () => {
        window.swellAPI.refreshCustomerDetails()
      })

      document.addEventListener('swell:customer:updated', () => {
        this.customerDetails = window.swellAPI.getCustomerDetails()
        this.renderPoints()
        this.renderTier()
        this.renderSpend()
        this.renderSpendSlider()
      })
    })
  }

  renderPoints () {
    const customerPointsBalance = this.customerDetails.pointsBalance
    const domElements = document.querySelectorAll('[data-loyalty-points]')

    if (domElements) {
      for (let i = 0; i < domElements.length; i++) {
        const el = domElements[i]
        el.textContent = `${customerPointsBalance}`
      }
    }
  }

  renderTier () {
    const customerTier = this.customerDetails.vipTier?.name
    const domElements = document.querySelectorAll('[data-loyalty-tier]')

    if (domElements && customerTier !== undefined) {
      for (let i = 0; i < domElements.length; i++) {
        const el = domElements[i]
        el.textContent = `${customerTier}`
      }
    }
  }

  renderSpend () {
    const customerSpendAmount = formatMoney(
      this.customerDetails.vipTierStatsNeeded?.amountSpentCents *
        window.Shopify.currency.rate,
    )
    const domElements = document.querySelectorAll('[data-loyalty-spend]')

    if (domElements) {
      for (let i = 0; i < domElements.length; i++) {
        const el = domElements[i]
        el.textContent = `${customerSpendAmount}`
      }
    }
  }

  renderPound () {
    const customerSpendAmount = formatMoney(100 * window.Shopify.currency.rate)
    const domElements = document.querySelectorAll('[data-loyalty-pound]')

    if (domElements) {
      for (let i = 0; i < domElements.length; i++) {
        const el = domElements[i]
        el.textContent = `${customerSpendAmount}`
      }
    }
  }

  renderSpendSlider () {
    const customerSpendAmount =
      (this.customerDetails.vipTierStats?.amountSpentCents /
        this.customerDetails.vipTierStatsNeeded?.amountSpentCents) *
      100
    const width =
      customerSpendAmount > 100
        ? 100
        : customerSpendAmount < 0
          ? 0
          : customerSpendAmount

    const domElements = document.querySelectorAll('[data-loyalty-spend-bar]')

    if (domElements) {
      for (let i = 0; i < domElements.length; i++) {
        const el = domElements[i]
        el.style.width = `${width}%`
      }
    }
  }

  set customerDetails (value) {
    this._customerDetails = value
  }

  get customerDetails () {
    return this._customerDetails
  }
}

window.BAO.Loyalty = new Loyalty()
